<template>
  <v-row
    class="pa-0 ma-0 status-label"
    justify="center"
    align="center"
    :class="[colorClass]"
  >
    {{ statusText }}
  </v-row>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    statusText() {
      let text = this.status
      if (text === 'To do') {
        text = 'Pending'
      }
      return text
    },
    colorClass() {
      return this.status.toLowerCase().split(' ').join('-')
    },
  },
}
</script>

<style lang="sass" scoped>
.status-label
  color: #fff
  border-radius: 5px
  height: 28px
  min-width: 106px
  max-width: 140px
  @include button
  &.pending
    background-color: $statusPending
  &.in-progress
    background-color: $statusInProgress
  &.completed
    background-color: $statusComplete
  &.blocked
    background-color: $statusBlocked
  &.approval
    background-color: $statusApproval
</style>